var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.9584C5.05866 18.9584 1.04199 14.9417 1.04199 10.0001C1.04199 5.05841 5.05866 1.04175 10.0003 1.04175C14.942 1.04175 18.9587 5.05841 18.9587 10.0001C18.9587 14.9417 14.942 18.9584 10.0003 18.9584ZM10.0003 2.29175C5.75033 2.29175 2.29199 5.75008 2.29199 10.0001C2.29199 14.2501 5.75033 17.7084 10.0003 17.7084C14.2503 17.7084 17.7087 14.2501 17.7087 10.0001C17.7087 5.75008 14.2503 2.29175 10.0003 2.29175Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08288 16.4583C3.92454 16.4583 3.76621 16.4 3.64121 16.275C3.39954 16.0333 3.39954 15.6333 3.64121 15.3916L15.3079 3.72495C15.5495 3.48328 15.9495 3.48328 16.1912 3.72495C16.4329 3.96662 16.4329 4.36662 16.1912 4.60828L4.52454 16.275C4.39954 16.4 4.24121 16.4583 4.08288 16.4583Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockicon);
export default __webpack_public_path__ + "static/media/blockicon.0eb547d4bbfbd1bb43c5f9ddd76209d5.svg";
export { ForwardRef as ReactComponent };